import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Expandable, Spinner, translate } from '@haldor/ui';
import { Form, Field } from "react-final-form";
import { content_from_plandata } from 'actions/ai';
import DOMPurify from 'dompurify';

class AIConversation extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loader: false,
			form: {
				Introduction: null,
				Assignment: null,
				TeacherGuidance: null,
				Quiz: null
			},
			earlierMessages: [],
			coreContent: [],
			courses: [],
			conversationId: null,
			age: 14,
		}
	}
	componentDidMount() {
		let coreContents = [];
		let courses = [];
		if (this.props.activePlan != null && this.props.activePlan.associatedCoreContent != null) {
			coreContents = this.props.activePlan.associatedCoreContent[0].coreContents;
			courses = this.props.activePlan.courses;
		}
		else if (this.props.selectedCoreContent != null && this.props.selectedCoreContent.length > 0) {
			coreContents = this.props.selectedCoreContent[0].coreContents;
			coreContents.forEach((coreContent) => {

				const sectionCorecontent = this.props.sections
					.flatMap(section => section.courses)
					.flatMap(course => course.details)
					.flatMap(courseDetails => courseDetails.coreContent)
					.find(cc => cc.courseDetailsId === coreContent.courseDetailsId);
				coreContent.title = sectionCorecontent.title;

				this.props.sections.find((section) => {
					section.courses.find((course) => {
						course.details.find((courseDetails) => {
							courseDetails.coreContent.find((cc) => {
								if (cc.courseDetailsId == coreContent.courseDetailsId) {
									courses.push(course);
								}
							})
						})
					})
				});

				coreContent.aspects.forEach((aspect) => {
					aspect.title = sectionCorecontent.aspects.find((a) => a.id === aspect.id).title;
					aspect.aspectRows.forEach((row) => {
						row.text = sectionCorecontent.aspects.find((a) => a.id === aspect.id).aspectRows.find((ar) => ar.id === row.id).text;
					})
				});
			})
		}
		else {
			coreContents = [];
		}
		if (coreContents.length > 0) {
			this.setState({ coreContent: coreContents });
		}
		if (courses.length > 0) {
			this.setState({ courses: courses });
		}

		// Do not call the API if there is no core content
		if (coreContents == null || coreContents.length == 0) {
			return;
		}

		let values = {
			coreContents: coreContents,
			courses: courses,
			age: 16,
			body: null
		}

		this.submitForUnit(values);
	}

	componentDidUpdate(prevProps) {
		// if (this.props.plans !== prevProps.plans && this.props.plans.length > 0) {
		// 	this.props.sendPlansToAPI(this.props.plans);
		// }
	}
	insertPlanContent = (content) => {
		this.props.onDataSend(content);
	}
	submitForUnit = (values) => {
		const { initialValues } = this.props;

		this.setState({ loader: true });
		let contentType = "Introduction";
		let earlierMessages = this.state.earlierMessages;
		let conversationId = this.state.conversationId;

		if (conversationId == null && (earlierMessages == null || earlierMessages.length == 0)) {
			const { v4: uuidv4 } = require('uuid');
			conversationId = uuidv4();
			this.setState({ conversationId: conversationId });
		}


		if (values?.body != null && values?.body.length > 0) {
			earlierMessages.push({
				content: values.body,
				timeStamp: new Date().toISOString(),
				messageType: "Request"
			});
		}

		let courses = values?.courses;
		if (courses == null || courses.length == 0) {
			courses = this.state.courses;
		}

		let coreContent = values?.coreContents;
		if (coreContent == null || coreContent.length == 0) {
			coreContent = this.state.coreContent;
		}

		let input = {
			id: conversationId,
			associatedCoreContents: coreContent,
			courses: courses,
			ages: [this.state.age],
			contentType: contentType,
			messages: earlierMessages
		}
		this.props.content_from_plandata(input, (data) => {
			// Remove sorrounding html tags
			if (data.introduction != null && data.introduction.length > 0) {
				data.introduction = data.introduction.replace(/<!DOCTYPE html>/gm, '');
				data.introduction = data.introduction.replace(/<\/?html>/gm, '');
				data.introduction = data.introduction.replace(/<\/?body>/gm, '');
				data.introduction = data.introduction.replace('\n', '');

				earlierMessages.push({
					content: data.introduction,
					timeStamp: new Date().toISOString(),
					messageType: "Response"
				});
				this.setState({ earlierMessages: earlierMessages });
			}
			this.setState({ Introduction: data.introduction });
			if (data.id != null && data.id != this.state.conversationId) {
				this.setState({ conversationId: data.id });
			}

			if (data.assignment.length > 0) {
				data.assignment[0] = data.assignment[0].replace(/<!DOCTYPE html>/gm, '');
				data.assignment[0] = data.assignment[0].replace(/<\/?html>/gm, '');
				data.assignment[0] = data.assignment[0].replace(/<\/?body>/gm, '');
				data.assignment[0] = data.assignment[0].replace('\n', '');
			}
			this.setState({ Assignment: data.assignment[0] });

			if (data.teacherGuidance) {
				data.teacherGuidance = data.teacherGuidance.replace(/<!DOCTYPE html>/gm, '');
				data.teacherGuidance = data.teacherGuidance.replace(/<\/?html>/gm, '');
				data.teacherGuidance = data.teacherGuidance.replace(/<\/?body>/gm, '');
				data.teacherGuidance = data.teacherGuidance.replace('\n', '');
			}
			this.setState({ TeacherGuidance: data.teacherGuidance });

			if (data.quiz.length > 0) {
				data.quiz[0] = data.quiz[0].replace(/<!DOCTYPE html>/gm, '');
				data.quiz[0] = data.quiz[0].replace(/<\/?html>/gm, '');
				data.quiz[0] = data.quiz[0].replace(/<\/?body>/gm, '');
				data.quiz[0] = data.quiz[0].replace('\n', '');
			}
			this.setState({ Quiz: data.quiz[0] });

			this.setState({ loader: false });
		});

		// const data = {
		// 	...values,
		// 	planId: initialValues.id,
		// };
	}
	renderTextarea = ({ input, label, type, placeholder }) => {
		return (
			<div>
				<textarea placeholder={placeholder || label} type={type} {...input}>
					{input.value}
				</textarea>
			</div>
		);
	}
	renderAgeInput = ({ input }) => {
		return (
			<div>
				<input
					{...input}
					style={{ width: 60 }}
					type="number"
					value={this.state.age}
					onChange={this.setAge}
					min="0"
					max="99"
				/>
			</div>
		);
	};
	number = (value) => {
		if (value != null && value != '') {
			// Value is not undefined and not empty
			const number = parseInt(value, 10);

			if (number > 2 && number < 100) {
				// Field passes validation, return a undefined error for this field
				// Rule: Not undefined and not an empty string and not below zero and not over 1400
				return null;
			}
		}

		// Field failed validation, return error for this field (String)
		return this.props.translate('Please enter a number between 3 and 99');
	};
	setAge = (event) => { if (event.target.value > 99) { event.target.value = 99; } this.setState({ age: event.target.value }) }

	render() {
		const forbiddenText = "Undervisningen i kursen ska behandla följande centrala innehåll:";

		return (
			<div className="form-container form">
				<Form
					onSubmit={this.submitForUnit}
					initialValues={this.props.activePlan}
					initialValuesEqual={() => true}
					render={({ submitting, handleSubmit, form, valid }) => {
						let coreContents = this.state.coreContent;
						return (
							<div>
								<form onSubmit={handleSubmit} className="form form-component">
									<div className="form-row">
										<div className="form-row-half">
											{this.state.loader == true
												? <Spinner center />
												: this.state.Introduction ?
													<div className="form-row post-content">
														<label>{this.props.translate('Introduction')}</label>
														<div
															dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.state.Introduction) }} />
														<Button
															onClick={(e) => {
																e.preventDefault();
																this.insertPlanContent(this.state.Introduction);
															}}>
															{this.props.translate("Insert to plan")}
														</Button>
													</div>
													: this.props.translate('No content was created. Please write a text and update if you would like to create content.')}
										</div>
										<div className="form-row-half last">
											<Expandable title={this.props.translate("core-contents")}>
												<div className="core-content">
													{coreContents.map((coreContent) => (
														<div key={coreContent.id}>
															<div>
																<h2>{coreContent.title}</h2>
															</div>

															{coreContent.aspects.map((aspect) => (
																<div key={'corecontent-aspects-' + aspect.id} className="aspects">
																	<h3>{aspect.title != forbiddenText ? aspect.title : ''}</h3>

																	{aspect.aspectRows.map((row) => {
																		return <div key={'aspect-row-' + row.id} className="aspect-row">
																			{row.text}
																		</div>
																	})}
																</div>
															))}
														</div>
													))}
												</div>
											</Expandable>
											<label>{this.props.translate('Age')}</label>
											<Field
												name='age'
												component={this.renderAgeInput} />

											<label>{this.props.translate('Extra info for content creation')}</label>

											<Field
												component={this.renderTextarea}
												name="body"
												type="text"
												placeholder={this.props.translate('Add extra information about your content here')}
												translate={this.props.translate}
											/>
											<Button
												onClick={(e) => {
													e.preventDefault();
													form.submit();
												}}
											>
												{this.props.translate("Update")}
											</Button>

										</div>
									</div>
									<div className="form-row spacing submit">
									</div>
									<div className="form-row">
									</div>
								</form>
							</div>
						)
					}}
				/>
			</div>)
	}
}

function mapStateToProps(state) {
	let activePlan = null;
	if (state.planning.active_plan != null) {
		activePlan = state.planning.active_plan;
	}
	return {
		activePlan,
		courses: state.Courses.courses,
		translate: translate(state.Languages.translations),
	};
};

// const mapDispatchToProps = (dispatch) => {
//     return {
//         fetchPlans: () => dispatch(fetchPlans()),
//         sendPlansToAPI: (plans) => dispatch(sendPlansToAPI(plans)),
//     };
// };

export default connect(mapStateToProps, {
	content_from_plandata
})(AIConversation);